/**
 * Nombres affichés à la française (13/10/2026) : virgule décimale, espace des milliers, espace insécable avant « % ».
 * Valeur absente ou non numérique : « — ».
 */
export function nombreFr(v: any, decimales = 0): string {
  const n = typeof v === 'string' ? parseFloat(v) : v
  if (n === null || n === undefined || isNaN(n)) return '—'
  return n.toLocaleString('fr-FR', { minimumFractionDigits: decimales, maximumFractionDigits: decimales })
}

export function pourcentFr(v: any, decimales = 1): string {
  const t = nombreFr(v, decimales)
  return t === '—' ? t : t + ' %'
}
